/* tslint:disable */

/* eslint-disable */

/**
 * SaasReport.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';

/**
 * TaReportsReportApi - axios parameter creator
 * @export
 */
export const TaReportsReportApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Retrieves in-service report data for a specific employee and returns it as a PDF file.
     * @param {number} employeeId The ID of the employee for whom the report is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    taReportsEmployeeInServiceDataEmployeeIdGet: async (
      employeeId: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'employeeId' is not null or undefined
      assertParamExists(
        'taReportsEmployeeInServiceDataEmployeeIdGet',
        'employeeId',
        employeeId
      );
      const localVarPath =
        `/TaReports/EmployeeInServiceData/{employeeId}`.replace(
          `{${'employeeId'}}`,
          encodeURIComponent(String(employeeId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TaReportsReportApi - functional programming interface
 * @export
 */
export const TaReportsReportApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TaReportsReportApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Retrieves in-service report data for a specific employee and returns it as a PDF file.
     * @param {number} employeeId The ID of the employee for whom the report is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async taReportsEmployeeInServiceDataEmployeeIdGet(
      employeeId: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.taReportsEmployeeInServiceDataEmployeeIdGet(
          employeeId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * TaReportsReportApi - factory interface
 * @export
 */
export const TaReportsReportApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TaReportsReportApiFp(configuration);
  return {
    /**
     *
     * @summary Retrieves in-service report data for a specific employee and returns it as a PDF file.
     * @param {TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    taReportsEmployeeInServiceDataEmployeeIdGet(
      requestParameters: TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .taReportsEmployeeInServiceDataEmployeeIdGet(
          requestParameters.employeeId,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for taReportsEmployeeInServiceDataEmployeeIdGet operation in TaReportsReportApi.
 * @export
 * @interface TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest
 */
export interface TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest {
  /**
   * The ID of the employee for whom the report is generated.
   * @type {number}
   * @memberof TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGet
   */
  readonly employeeId: number;
}

/**
 * TaReportsReportApi - object-oriented interface
 * @export
 * @class TaReportsReportApi
 * @extends {BaseAPI}
 */
export class TaReportsReportApi extends BaseAPI {
  /**
   *
   * @summary Retrieves in-service report data for a specific employee and returns it as a PDF file.
   * @param {TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaReportsReportApi
   */
  public taReportsEmployeeInServiceDataEmployeeIdGet(
    requestParameters: TaReportsReportApiTaReportsEmployeeInServiceDataEmployeeIdGetRequest,
    options?: AxiosRequestConfig
  ) {
    return TaReportsReportApiFp(this.configuration)
      .taReportsEmployeeInServiceDataEmployeeIdGet(
        requestParameters.employeeId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
